import "core-js";
import "regenerator-runtime/runtime";
import eotwJSXFactory from "base/eotwJSXFactory";
import GlobalEvents from "base/GlobalEvents";

import $ from "jquery";
import "jquery-serializejson";
import svg4everybody from "svg4everybody";
import "objectFitPolyfill";

import Page from "webPage/Page";
import PageAnimations from "webPage/PageAnimations";
import {handleStickyNav} from "util/handleStickyNav";
import VideoModal from "modal/VideoModal";

let windowWidth = 0;

$(function () {
    if (window.jsLoadTimeout) {
        clearTimeout(window.jsLoadTimeout);
    }

    document.documentElement.setAttribute('data-useragent', navigator.userAgent);
    if (!!window.MSInputMethodContext && !!document.documentMode) {
        $('html').addClass('ie11');
    }

    svg4everybody();
    PageAnimations.start();
    Page.init();
    handleStickyNav();

    let $client_logos = $('.js-client-logos');

    if ($client_logos.length > 0) {
        setInterval(() => {
            rotateLogos()
        }, 4500);
    }

    $('body').on('click', '.js-toggle-nav', () => {
        $('body').toggleClass('nav-active').removeClass('sub-nav-active');
        $('.sub-nav').removeClass('sub-nav--active');
        return false;
    }).on('click', '.js-sub-nav-toggle', function () {
        $(this).next('.sub-nav').toggleClass('sub-nav--active');
        $('body').addClass('sub-nav-active');
    }).on('click', '.js-close-sub-nav', function () {
        $(this).closest('.sub-nav').toggleClass('sub-nav--active');
        $('body').removeClass('sub-nav-active');
    }).on('click', '.js-toggle-accordion', function () {
        if (windowWidth < 760) {
            $(this).next('.accordion__body').stop().slideToggle();
            $(this).parent('.accordion').toggleClass('accordion--active')
        }
    }).on('click', '.js-apply', function () {
        $('body').addClass('modal-active');
        $('.js-apply-modal').addClass('modal--active');

        return false;
    }).on('click', '.js-close-modal', function () {
        $('body').removeClass('modal-active');
        $('.js-apply-modal').removeClass('modal--active');
    }).on('click', '.js-video-modal', function () {
        let modal = new VideoModal($(this));
        modal.show();
        return false;
    });

    $(window).on('scroll load resize', () => {
        windowWidth = $(window).outerWidth();

        $('.js-sketch-circle').css("transform", "rotate(" + $(window).scrollTop() / 30 + "deg)");
        $('.js-hero-logo').css({
            "transform": "translateY(-50%) translateX(-" + $(window).scrollTop() / 10 + "px)"
        });

        if ($(window).width() >= 960) {
            $('body').removeClass('nav-active sub-nav-active');
            $('.sub-nav').removeClass('sub-nav--active')
        }
    });

    $(document).on('gform_confirmation_loaded', function (event, formId) {
        try {
            if (formId === 1 /* Contact Form */) {
                dataLayer.push({'event': 'submit-contact'});
            } else if (formId === 2 /* Careers Form */) {
                dataLayer.push({'event': 'submit-careers'});
            }
        } catch (e) {
            console.log(e);
        }
    });

    appHeight();
});

function appHeight() {
    let doc = document.documentElement;
    doc.style.setProperty('--screen-height', $(window).innerHeight() + 'px');
}

export function svg_include(icon, suffix = '') {
    return '<svg><use xlink:href="/wp-content/themes/randle-engineering/includes/svg-icons.svg?#' + icon + '"></use></svg>';
}

export function rotateLogos() {
    let $all_visible = $('.js-logo.client-logos__item--active');
    let $visible = $all_visible.eq(Math.round(Math.random() * ($all_visible.length - 1)));
    let $all_hidden = $('.js-logo.client-logos__item--hidden');
    let $hidden = $all_hidden.eq(Math.round(Math.random() * ($all_hidden.length - 1)));

    $visible.removeClass('client-logos__item--active');

    setTimeout(() => {
        $visible.after($hidden);
        $visible.addClass('client-logos__item--hidden');
        $hidden.removeClass('client-logos__item--hidden');

        setTimeout(() => {
            $hidden.addClass('client-logos__item--active');
        });
    }, 400);
}

window.$ = window.jQuery = $;
window.eotwJSXFactory = eotwJSXFactory;
window.GlobalEvents = GlobalEvents;
